/* Shortlist entries are intentionally allowed to repeat (the same shade can be
   added twice, e.g. once as a than and once as a bundle), so the shade number is
   NOT a unique key. Every entry carries its own id instead. */
let counter = 0;

export const newCartId = () =>
  `${Date.now().toString(36)}-${(counter++).toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

/** Backfills ids for carts saved before ids existed. */
export const withCartIds = (items) =>
  (Array.isArray(items) ? items : []).map((it) =>
    it && it.id ? it : { ...it, id: newCartId() }
  );
